import React, { Component } from "react"
import "./userProfileInfo.scss"
import { Link, withRouter } from "react-router-dom"
import { bindActionCreators } from "redux"
import {
  getData,
  signOut,
} from "../../../../../library/store/actions/creators/authCreators"
import { connect } from "react-redux"
import UserProfilePublicCounters from "../userProfilePublicCounters/userProfilePublicCounters"
import defaultDate, {
  defaultMaxDate,
  defaultNumberDate,
  defaultNumberMaxDate,
} from "../../../../../library/constants/defaultDates"
import { format } from "date-fns"

const InfoTableRow = ({ label, value }) => {
  return (
    <div className="info-table__row !justify-start gap-8">
      <div className="info-table__label">{label}:</div>
      <div className="info-table__value">
        <pre className="break-word">{value}</pre>
      </div>
    </div>
  )
}

const InfoTableRowEducation = ({ type, name, from, to, ...rest }) => {
  let inst, dep
  switch (type) {
    case 1:
    case 2:
    case 3:
      inst = "School"
      dep = ""
      break
    case 4:
      inst = "College/University"
      dep = "Major"
      break
    case 5:
      inst = "School"
      dep = "Training"
      break
    case 6:
      inst = "School"
      dep = "Certification"
      break
    default:
      inst = "Institution"
      dep = "Department"
  }

  const departmentInfo = rest.department ? (
    <div className="info-table__row !justify-start gap-8">
      <div className="info-table__label">{dep}:</div>
      <div className="info-table__value">
        <pre className="break-word">{rest.department}</pre>
      </div>
    </div>
  ) : null

  const studyStarted =
    from && from !== defaultDate && from !== defaultNumberDate
      ? new Date(from).getFullYear()
      : ""
  const studyFinished =
    to && to !== defaultMaxDate && to !== defaultNumberMaxDate
      ? new Date(to).getFullYear()
      : ""
  const showPeriod = studyStarted !== ""
  return (
    <>
      <div className="info-table__row !justify-start gap-8">
        <div className="info-table__label">{inst}:</div>
        <div className="info-table__value">
          <pre className="break-word">
            {name}
            {showPeriod
              ? `, ${studyStarted} ${studyFinished ? "- " + studyFinished : ""}`
              : null}
          </pre>
        </div>
      </div>
      {departmentInfo}
    </>
  )
}

const InfoTableRowWork = ({ name, role, from, to, userRole, ...rest }) => {
  const workStarted =
    from && from !== defaultDate && from !== defaultNumberDate
      ? new Date(from).getFullYear()
      : ""
  const workFinished =
    to && to !== defaultMaxDate && to !== defaultNumberMaxDate
      ? new Date(to).getFullYear()
      : ""

  const showPeriod = workStarted !== ""

  return (
    <>
      <div className="info-table__row !justify-start gap-8">
        <div className="info-table__label">
          {userRole === 1 || userRole === 2 ? "Institution" : "Company"} name:
        </div>
        <div className="info-table__value">
          <pre className="break-word">
            {name}
            {showPeriod
              ? `, ${workStarted} ${workFinished ? "- " + workFinished : ""}`
              : null}
          </pre>
        </div>
      </div>
      {!!role && (
        <div className="info-table__row !justify-start gap-8">
          <div className="info-table__label">Position:</div>
          <div className="info-table__value">
            <pre className="break-word">{role}</pre>
          </div>
        </div>
      )}
      {!!rest.description && (
        <div className="info-table__row !justify-start gap-8">
          <div className="info-table__label">About:</div>
          <div className="info-table__value">
            <pre className="break-word">{rest.description}</pre>
          </div>
        </div>
      )}
    </>
  )
}

class UserProfileInfo extends Component {
  state = {
    active: "main",
    userInfo:
      this.props.type === "my-profile"
        ? this.props.auth.userData
        : this.props.person.personData,
    type: this.props.type,
  }

  componentDidMount() {
    if (this.hasMainInfo()) {
      this.setState({ active: "main" })
    } else if (this.hasContactsInfo()) {
      this.setState({ active: "contacts" })
    } else if (this.hasEducationInfo()) {
      this.setState({ active: "education" })
    } else if (this.hasWorkInfo()) {
      this.setState({ active: "work" })
    } else if (this.hasPersonalInfo()) {
      this.setState({ active: "personal" })
    }
  }

  switchTabContent(value) {
    this.setState({ active: value })
  }

  composeLinks(arr) {
    return arr.map((item, i) => {
      if (i < arr.length - 1) {
        return (
          <span className="color-primary" key={item.url}>
            <Link to={item.url} className="link">
              {item.name}
            </Link>
            ,{" "}
          </span>
        )
      } else {
        return (
          <Link to={item.url} className="link" key={item.name}>
            {item.name}
          </Link>
        )
      }
    })
  }

  composePhones = (arr) => {
    return arr.map((item, i) => {
      if (i < arr.length - 1) {
        return (
          <a href={`tel:${item}`} className="link" key={item}>
            {item}
          </a>
        )
      } else {
        return (
          <a href={`tel:${item}`} className="link" key={item}>
            {item}
          </a>
        )
      }
    })
  }

  composeEducation = (arr) => {
    const copy = arr.slice()
    copy.sort((a, b) => b.date_from - a.date_from)

    return copy.map(({ id, type, name, date_from, date_to, ...rest }) => {
      return (
        <InfoTableRowEducation
          type={type}
          name={name}
          from={new Date(date_from).getTime()}
          to={new Date(date_to).getTime()}
          rest={rest}
          key={id}
        />
      )
    })
  }

  composeWork = (arr, userRole) => {
    const copy = arr.slice()

    copy.sort((a, b) => b.date_from - a.date_from)

    return copy.map(({ id, name, role, date_from, date_to, ...rest }) => {
      return (
        <InfoTableRowWork
          name={name}
          role={role}
          from={date_from}
          to={date_to}
          userRole={userRole}
          rest={rest}
          key={id}
        />
      )
    })
  }

  hasMainInfo = () => {
    const { userInfo } = this.state
    return !!(
      userInfo?.status.trim() ||
      // userInfo?.birthdate !== defaultDate ||
      userInfo?.city.trim() ||
      userInfo?.state.trim() ||
      userInfo?.country.trim() ||
      userInfo?.educations?.length > 0
    )
  }

  hasContactsInfo = () => {
    const { userInfo } = this.state
    return userInfo?.phones?.length > 0
  }

  hasEducationInfo = () => {
    const { userInfo } = this.state
    return userInfo?.educations?.length > 0
  }

  hasWorkInfo = () => {
    const { userInfo } = this.state
    return userInfo?.works?.length > 0
  }

  hasPersonalInfo = () => {
    const { userInfo } = this.state
    return !!(
      userInfo?.birthdate !== defaultDate ||
      userInfo?.interests.trim() ||
      userInfo?.favorite_films.trim() ||
      userInfo?.favorite_books.trim() ||
      userInfo?.favorite_games.trim() ||
      userInfo?.favorite_quotes.trim() ||
      userInfo?.favorite_subjects.trim()
    )
  }

  render() {
    const { active, userInfo, type } = this.state

    const mainInfo = (
      <>
        {userInfo && userInfo.status ? (
          <InfoTableRow label="Favorite quote" value={userInfo.status} />
        ) : null}
        {userInfo && userInfo.city ? (
          <InfoTableRow label="City" value={userInfo.city} />
        ) : null}
        {userInfo && userInfo.state ? (
          <InfoTableRow label="State" value={userInfo.state} />
        ) : null}
        {userInfo && userInfo.country ? (
          <InfoTableRow label="Country" value={userInfo.country} />
        ) : null}
      </>
    )

    const contactsInfo = (
      <>
        {userInfo && userInfo.phones && userInfo.phones.length > 0 ? (
          <InfoTableRow
            label="Contact phone"
            value={this.composePhones(userInfo.phones)}
          />
        ) : null}
      </>
    )

    const educationInfo = (
      <>
        {userInfo && userInfo.educations
          ? this.composeEducation(userInfo.educations)
          : null}
      </>
    )
    const workInfo = (
      <>
        {userInfo && userInfo.works
          ? this.composeWork(userInfo.works, userInfo.role)
          : null}
      </>
    )

    const personalInfo = (
      <>
        {userInfo &&
        userInfo.birthdate &&
        userInfo.birthdate !== defaultDate ? (
          <InfoTableRow
            label="Date of birth"
            value={format(new Date(userInfo.birthdate), "d MMMM yyyy")}
          />
        ) : null}
        {userInfo && userInfo.interests ? (
          <InfoTableRow label="Interests" value={userInfo.interests} />
        ) : null}
        {userInfo && userInfo.favorite_subjects ? (
          <InfoTableRow
            label="Favorite subjects"
            value={userInfo.favorite_subjects}
          />
        ) : null}
        {userInfo && userInfo.favorite_films ? (
          <InfoTableRow
            label="Favorite films"
            value={userInfo.favorite_films}
          />
        ) : null}
        {userInfo && userInfo.favorite_books ? (
          <InfoTableRow
            label="Favorite books"
            value={userInfo.favorite_books}
          />
        ) : null}
        {userInfo && userInfo.favorite_games ? (
          <InfoTableRow
            label="Favorite games"
            value={userInfo.favorite_games}
          />
        ) : null}
        {userInfo && userInfo.favorite_quotes ? (
          <InfoTableRow
            label="Favorite quotes"
            value={userInfo.favorite_quotes}
          />
        ) : null}
      </>
    )

    const InfoContent = () => {
      switch (active) {
        case "main":
          return mainInfo

        // case "contacts":
        //     return contactsInfo;

        case "education":
          return educationInfo

        case "work":
          return workInfo

        case "personal":
          return personalInfo

        default:
          return mainInfo
      }
    }

    const hasInfo =
      this.hasMainInfo() ||
      this.hasPersonalInfo() ||
      // || this.hasContactsInfo()
      this.hasEducationInfo() ||
      this.hasWorkInfo()

    return (
      <section className={`box user-profile-info ${!hasInfo ? "pt15" : ""}`}>
        {hasInfo && (
          <>
            <div className="user-profile-info__data">
              <nav className="user-profile-info__nav">
                <ul className="menu">
                  {this.hasMainInfo() ? (
                    <li className="menu__item">
                      <span
                        role="button"
                        className={`menu__link link  ${
                          this.state.active === "main"
                            ? "menu__link--active"
                            : ""
                        }`}
                        onClick={() => this.switchTabContent("main")}
                      >
                        Main
                      </span>
                    </li>
                  ) : null}

                  {/*{this.hasContactsInfo() ? (*/}
                  {/*    <li className="menu__item">*/}
                  {/*        <span role="button"*/}
                  {/*              className={`menu__link link  ${this.state.active === "contacts" ? "menu__link--active" : ""}`}*/}
                  {/*              onClick={() => this.switchTabContent("contacts")}>*/}
                  {/*            Contacts*/}
                  {/*        </span>*/}
                  {/*    </li>*/}
                  {/*) : null*/}
                  {/*}*/}

                  {this.hasEducationInfo() ? (
                    <li className="menu__item">
                      <span
                        role="button"
                        className={`menu__link link  ${
                          this.state.active === "education"
                            ? "menu__link--active"
                            : ""
                        }`}
                        onClick={() => this.switchTabContent("education")}
                      >
                        Education
                      </span>
                    </li>
                  ) : null}

                  {this.hasWorkInfo() ? (
                    <li className="menu__item">
                      <span
                        role="button"
                        className={`menu__link link  ${
                          this.state.active === "work"
                            ? "menu__link--active"
                            : ""
                        }`}
                        onClick={() => this.switchTabContent("work")}
                      >
                        Work
                      </span>
                    </li>
                  ) : null}

                  {this.hasPersonalInfo() ? (
                    <li className="menu__item">
                      <span
                        role="button"
                        className={`menu__link link  ${
                          this.state.active === "personal"
                            ? "menu__link--active"
                            : ""
                        }`}
                        onClick={() => this.switchTabContent("personal")}
                      >
                        Personal
                      </span>
                    </li>
                  ) : null}
                </ul>
              </nav>
              <div className="v-divider"></div>
              <div className="user-profile-info__content">
                <div className="info-table">
                  <InfoContent />
                </div>
              </div>
            </div>
            <div className="h-divider"></div>
          </>
        )}
        <UserProfilePublicCounters userInfo={userInfo} type={type} />
      </section>
    )
  }
}

const mapStateToProps = ({ auth, person }) => ({ auth, person })
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ signOut, getData }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(UserProfileInfo))
